import { ErrorToaster } from "components/common/toast";
import ImageUpload from "components/CustomUpload/ImageUpload";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, InputGroup, Modal, ModalBody } from "reactstrap";

function ModalUploadProfile(props) {
  const { setFieldValue, value, open, setOpen, setConfirm } = props;
  const { t } = useTranslation("common");
  const [error, setError] = useState("");

  const handleClose = () => {
    setFieldValue("profile", "");
    setOpen(!open);
  };
  const handleConfirm = () => {
    if (value && !error) {
      setConfirm(true);
      setOpen(!open);
    } else {
      ErrorToaster(t("uploadProfile.selectImage"));
    }
  };
  return (
    <Modal isOpen={open} toggle={handleClose}>
      <div className="modal-header justify-content-center">
        <button
          aria-hidden={true}
          className="close"
          type="button"
          onClick={handleClose}
        >
          <i className="tim-icons icon-simple-remove" />
        </button>
      </div>
      <ModalBody className="text-center">
        <div className="custom_input">
          <InputGroup className="justify-content-center">
            <ImageUpload
              name="profile"
              changeBtnClasses="btn-simple"
              addBtnClasses="btn-simple"
              removeBtnClasses="btn-simple"
              setFieldValue={setFieldValue}
              value={value}
              error={error}
              setError={setError}
            />
          </InputGroup>
          {error && (
            <span className="error-upload-image text-danger">{error}</span>
          )}
        </div>
        <Button color="default" type="button" onClick={handleConfirm}>
          {t("actions.confirm")}
        </Button>
        <Button
          color="danger"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          {t("actions.close")}
        </Button>
      </ModalBody>
    </Modal>
  );
}

export default ModalUploadProfile;
